import React from 'react';

export type Direction = 'up' | 'down' | 'left' | 'right';

export const getNextOptionToFocus = (
  optionsGrid: number[][],
  currentlyFocusedOptionGridIndex: [number, number] | null,
  direction: Direction,
) => {
  let currentRow = 0;
  let currentColumn = 0;
  let newRow = 0;
  let newColumn = 0;

  if (currentlyFocusedOptionGridIndex != null) {
    currentRow = currentlyFocusedOptionGridIndex[0];
    currentColumn = currentlyFocusedOptionGridIndex[1];

    newRow = currentRow;
    newColumn = currentColumn;

    switch (direction) {
      case 'up':
        newRow -= 1;
        break;
      case 'down':
        newRow += 1;
        break;
      case 'left':
        newColumn -= 1;
        break;
      case 'right':
        newColumn += 1;
        break;
    }
  }

  if (newRow < 0 || newRow >= optionsGrid.length) {
    newRow = currentRow;
  }
  if (newColumn < 0) {
    newColumn = currentColumn;
  } else if (newColumn >= optionsGrid[newRow].length) {
    newColumn = optionsGrid[newRow].length - 1; // set newColumn to last column in row if newRow has fewer column than currentRow
  }

  const newOptionGridIndex: [number, number] = [newRow, newColumn];
  const nextFocusRefIndex = optionsGrid[newRow][newColumn];

  return {
    newOptionGridIndex,
    newOptionIndex: nextFocusRefIndex,
  };
};

export const generateOptionsGrid = (optionRefs: React.RefObject<HTMLButtonElement | null>[]) => {
  const wrappedItems: number[][] = [[]];
  let previousItem: DOMRect | null = null;
  let currentItem: DOMRect | null = null;
  let currentRow = 0;

  optionRefs.forEach((ref, index) => {
    if (!ref.current) return;

    currentItem = ref.current.getBoundingClientRect();

    if (previousItem && previousItem.top < currentItem.top) {
      currentRow += 1;
      wrappedItems.push([]);
    }

    wrappedItems[currentRow].push(index);

    previousItem = currentItem;
  });

  return wrappedItems;
};
